import React from "react";
import "./mobileMenu.scss";
import { NavLink } from "react-router-dom";

const MobileMenu = () => {
  return (
    <div className="mobile">
      <input id="toggle" type="checkbox" />
      <label className="toggle-container" htmlFor="toggle">
        <span className="button button-toggle"></span>
      </label>
      <nav className="nav">
        <NavLink className="nav-item" to="/" activeClassName="active" exact>
          Popular
        </NavLink>
        <NavLink className="nav-item" to="/upcoming" activeClassName="active">
          Upcoming
        </NavLink>
        <NavLink className="nav-item" to="/playing" activeClassName="active">
          Playing
        </NavLink>
        <NavLink className="nav-item" to="/favorites" activeClassName="active">
          Favorites
        </NavLink>
      </nav>
    </div>
  );
};

export default MobileMenu;
